module.exports = __webpack_public_path__ + "static/media/photo18.2ebb25c2.jpg";